import { useState, useRef, useEffect } from "react";
import { Stage, Layer, Circle, Arrow, Group } from "react-konva";
import PitchSvg from "./PitchSvg";

const Pitch = ({
  data,
  fieldWidth,
  fieldHeight,
  onMouseDownHandler = () => {},
  onMouseMoveHandler = () => {},
  onMouseUpHandler = () => {},
  children = null,
}) => {
  const divRef = useRef(null);
  const [pitchWidth, setPitchWidth] = useState(0);
  const [pitchHeight, setPitchHeight] = useState(0);
  const [hoveredCircle, setHoveredCircle] = useState(null);
  const [xRatio, setXRatio] = useState(1);
  const [yRatio, setYRatio] = useState(1);

  useEffect(() => {
    if (divRef.current) {
      const divWidth = divRef.current.clientWidth;
      const divHeight = divRef.current.clientHeight;
      setPitchWidth(divWidth);
      setPitchHeight(divHeight);
    }
  }, []);

  useEffect(() => {
    if (!fieldWidth || !fieldHeight || !pitchWidth || !pitchHeight) return;
    setXRatio(fieldWidth ? pitchWidth / fieldWidth : 1);
    setYRatio(fieldHeight ? pitchHeight / fieldHeight : 1);
  }, [fieldWidth, fieldHeight, pitchWidth, pitchHeight]);

  const handleMouseEnter = (index) => {
    setHoveredCircle(index);
  };

  const handleMouseLeave = () => {
    setHoveredCircle(null);
  };

  return (
    <div ref={divRef} className="pitch">
      <div className="pitch-svg-container">
        <PitchSvg />
      </div>
      <Stage
        className="pitch-stage"
        width={pitchWidth}
        height={pitchHeight}
        onMouseDown={onMouseDownHandler}
        onMouseMove={onMouseMoveHandler}
        onMouseUp={onMouseUpHandler}
      >
        <Layer>
          {data &&
            data.map((e, index) => {
              return (
                <Group key={index}>
                  {e.extra?.coords_start && e.extra?.coords_finish ? (
                    <>
                      <Circle
                        x={e.extra.coords_start[0] * xRatio}
                        y={e.extra.coords_start[1] * yRatio}
                        radius={7}
                        fill="blue"
                      />
                      <Circle
                        x={e.extra.coords_finish[0] * xRatio}
                        y={e.extra.coords_finish[1] * yRatio}
                        radius={7}
                        fill="blue"
                      />
                      <Arrow
                        points={[
                          e.extra.coords_start[0] * xRatio,
                          e.extra.coords_start[1] * yRatio,
                          e.extra.coords_finish[0] * xRatio,
                          e.extra.coords_finish[1] * yRatio,
                        ]}
                        fill="blue"
                        stroke="blue"
                      />
                    </>
                  ) : null}
                </Group>
              );
            })}
          {children}
        </Layer>
      </Stage>
    </div>
  );
};

export default Pitch;
